import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/srv/feelgood-dev2/node_modules/next/dist/client/app-dir/link.js");
